import type { UnreadNotificationsBadgeProps } from './Notifications.types';
import type { ReactElement } from 'react';

import { Text } from '@rango-dev/whale';
import React from 'react';

import styles from './Notifications.module.css';

export function UnreadNotificationsBadge(
  props: UnreadNotificationsBadgeProps,
): ReactElement | null {
  if (!props.count) {
    return null;
  }

  return (
    <span className={styles.badge}>
      <Text size="1" weight="medium">
        {props.count}
      </Text>
    </span>
  );
}
